import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
/**
 * Styles
 */
var useStyles = makeStyles({
    root: {
        height: '100%',
        zIndex: 10,
        '& a:focus': {
            outline: 'none',
        },
    },
});
/**
 * Top navigation logo
 */
export var TopNavigationLogoContainer = function (_a) {
    var children = _a.children, className = _a.className;
    var classes = useStyles();
    return React.createElement("div", { className: clsx(classes.root, className) }, children);
};
//# sourceMappingURL=TopNavigationLogoContainer.js.map